import React from 'react';
import { TrendingUp, DollarSign, Clock, Users } from 'lucide-react';

const ResultsSection = () => {
  const results = [
    {
      icon: Clock,
      metric: '85%',
      label: 'Faster Time-to-Hire',
      description: 'Compared to traditional recruiting',
    },
    {
      icon: DollarSign,
      metric: '60%',
      label: 'Cost Savings',
      description: 'On recruitment & overhead',
    },
    {
      icon: TrendingUp,
      metric: '3x',
      label: 'Faster Scaling',
      description: 'For engineering teams',
    },
    {
      icon: Users,
      metric: '98%',
      label: 'Retention Rate',
      description: 'After trial period',
    },
  ];

  return (
    <section className="bg-gradient-to-b from-[#0a0a0b] to-purple-900/10 py-24 px-6">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-green-500/10 border border-green-500/20 text-sm text-green-400 mb-6">
            Proven Results
          </div>
          <h2 className="text-4xl md:text-5xl text-white font-normal mb-4">
            Real impact for <span className="italic font-light">real businesses.</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Our clients see measurable improvements in their hiring process and team performance.
          </p>
        </div>

        {/* Results Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {results.map((result, index) => {
            const Icon = result.icon;
            return (
              <div
                key={index}
                className="text-center p-8 rounded-3xl bg-[#1a1a1f] border border-white/5 hover:border-purple-500/30 transition-all duration-500 group"
              >
                <div className="w-14 h-14 rounded-2xl bg-purple-600/20 flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                  <Icon className="w-7 h-7 text-purple-400" />
                </div>
                <div className="text-5xl font-bold text-white mb-2 bg-gradient-to-r from-white to-purple-400 bg-clip-text text-transparent">
                  {result.metric}
                </div>
                <div className="text-white font-medium mb-1">{result.label}</div>
                <div className="text-gray-500 text-sm">{result.description}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ResultsSection;
